/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GlycemicDetailsAliases {
  ACTION_PANEL = 'action-panel',
  ADMINISTRATION_BUTTON = 'administration-button',
  BODY_CONTEXTUAL_BAR = 'body-contextual-bar',
  BODY_PANEL = 'body-panel',
  DETAILS_DECK = 'details-deck',
  GLOBAL_ACTIONS = 'global-actions',
  GLYCEMIC_DETAILS_CARD = 'glycemic-details-card',
  GLYCEMIC_DETAILS_LAYOUT = 'glycemic-details-layout',
  HEADER_PANEL = 'header-panel',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  PERFORM_ACTION = 'perform-action',
  RESCHEDULE_GLYCEMIC_ACTION = 'reschedule-glycemic-action',
  SUSPEND_GLYCEMIC_ACTION = 'suspend-glycemic-action',
}
export { GlycemicDetailsAliases };
